// extracted by mini-css-extract-plugin
export default {"list":"styles-module__list__src-labstep-web-components-Signature-List-__CvpA"};